import {tolgee} from '../../integrations/tolgee/instance.js'
import {TolgeeProvider as TProvider} from '@tolgee/react'
import {PropsWithChildren} from 'react'
import {ZodLocales} from './zod-locales.js'

export function TolgeeProvider({children}: PropsWithChildren) {
  return (
    <TProvider tolgee={tolgee} options={{useSuspense: true}}>
      <ZodLocales>{children}</ZodLocales>
    </TProvider>
  )
}
